import { render, staticRenderFns } from "./ConsumptionDetails.vue?vue&type=template&id=573de101&scoped=true&"
import script from "./ConsumptionDetails.vue?vue&type=script&lang=js&"
export * from "./ConsumptionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573de101",
  null
  
)

export default component.exports